// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Image from './image';

class People extends Component {
	static slug = 'fl_people';

	getImage(imgUrl) {
		return (
			<Image imageURL={imgUrl} />
		);
	}

	getManualPerson() {
		const person = {};

		person.name = this.props.name;
		person.bio = this.props.content().props.content;
		person.image = this.getImage(this.props.image);
		person.profile_url = {
			url: this.props.link,
			label: 'See Profile',
		};
		person.contact_url = {
			url: this.props.contact_link,
			label: 'Contact Now',
		};
		person.container_classes = 'fl-bio t-content fl-col fl-bio--right';

		return person;
	}

	render() {
		let person = false;

		if (typeof this.props.person_details.data !== 'undefined' && this.props.type === 'select') {
			person = this.props.person_details.data;
			person.image = this.getImage(person.image_url);
		}

		if (this.props.type === 'manual') {
			person = this.getManualPerson();
		}

		if (!person) {
			return null;
		}

		return (
			<div className="fl-component et_pb_module et_pb_team_member" id={this.props.id}>
				<div className={person.container_classes}>
					{person.image &&
					<div className="fl-bio__image et_pb_team_member_image">
						{person.image}
					</div>
					}
					<div className="fl-bio__content et_pb_team_member_description">
						<h4 className="fl-bio__name et_pb_module_header">{person.name}</h4>
						<p className="fl-bio__desc" dangerouslySetInnerHTML={{ __html: person.bio }} />
						{person.profile_url.url &&
						<a className="fl-bio__link" href={person.profile_url.url}>
							<i className="icon icon-person" aria-hidden="true" />
							{person.profile_url.label}
						</a>
						}
					</div>
				</div>
			</div>
		);
	}
}

People.propTypes = {
	id: PropTypes.string.isRequired,
	person_details: PropTypes.object,
	type: PropTypes.string.isRequired,
	content: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired,
	contact_link: PropTypes.string.isRequired,
};

People.defaultProps = {
	person_details: {},
};

export default People;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/people.js